export const STEP_INCREMENT = 5;

export const OrderType = {
  GRUBHUB_DELIVERY: "GHD",
  SELF_DELIVERY: "SD",
  PICKUP: "PU",
};

export const PREP_TIME_MIN_MAX = {
  [OrderType.GRUBHUB_DELIVERY]: {
    min: 5,
    max: 55,
  },
  [OrderType.SELF_DELIVERY]: {
    min: 20,
    max: 120,
  },
  [OrderType.PICKUP]: {
    min: 5,
    max: 55,
  },
};

export const PREP_TIME_DEFAULTS = {
  [OrderType.GRUBHUB_DELIVERY]: 5,
  [OrderType.SELF_DELIVERY]: 20,
  [OrderType.PICKUP]: 5,
};


// WEBPACK FOOTER //
// ./client/app/components/foodPrepTime/foodPrepTimeConstants.js